module.exports = __webpack_public_path__ + "media/images/game_icon/th/VGSEAFOOD2-ad112953ecfb024e146d91f92cb8b56b.png";